import { DotsHorizontal, Trash01 } from '@untitled-ui/icons-react/build/cjs';
import React, { useState } from 'react';
import ActionTooltip from 'src/components/ActionTooltip';
import ButtonCmp from 'src/components/ButtonCmp';
import SelectBox from 'src/components/SelectBox/SelectBox';

const QUOTE_PRIORITY_OPTIONS = [{ value: 'print_packing_slips', label: 'Print packing slips' }];

const QuoteBulkActionBar = () => {
    const [quotePriorityAction, setQuotePriorityAction] = useState<any>(null);

    const handleCreateLabel = () => {};

    return (
        <>
            <SelectBox
                name="quotePriorityAction"
                options={QUOTE_PRIORITY_OPTIONS}
                value={quotePriorityAction}
                onChangeFunc={(option: any) => setQuotePriorityAction(option)}
                placeholder="Quote Priority"
                size="sm"
                parentClassName="hidden table-selection-selectbox w-[150px] flex-none"
                SelectDropdownWrapClass="table-selection-selectbox-dropdown filter-select-dropdown-md"
                isHideDropdownIndicator={false}
                isClearable={false}
            />

            <ButtonCmp className="hidden btn_white !py-1 !text-grayLight600 !font-medium !rounded-lg flex-none" onClick={handleCreateLabel}>
                Create Label
            </ButtonCmp>
            <ActionTooltip
                actionTooltipCustomClass=" action-tooltip-without-arrow"
                message={
                    <>
                        <ul className="action-tooltip-select min-w-[80px]">
                            <li className="action-tooltip-select-item">
                                <Trash01 className="action-tooltip-select-item-icon text-fgErrorPrimary" />
                                <p className={`action-tooltip-select-item-title text-fgErrorPrimary`}>Delete</p>
                            </li>
                        </ul>
                    </>
                }
                tooltipPosition="right"
                parentClassName="action-tooltip-select-wrap"
                childrenClassName="!flex"
            >
                <ButtonCmp
                    className="hidden btn_white !py-1 !text-grayLight600 !font-medium !rounded-lg flex-none"
                    icon={
                        <>
                            <DotsHorizontal className="w-4 h-4" />
                        </>
                    }
                    onClick={handleCreateLabel}
                >
                    <></>
                </ButtonCmp>
            </ActionTooltip>
        </>
    );
};

export default QuoteBulkActionBar;
